export enum BadgeVariant {
  ERROR = 'error',
  WARNING = 'warning',
  SUCCESS = 'success',
  INFO = 'info',
}

export enum AlertVariant {
  BRAND = 'brand',
  ERROR = 'error',
  WARNING = 'warning',
  SUCCESS = 'success',
  NEUTRAL = 'neutral',
}

export enum IconSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}
